export const MAX_ATTACHMENTS_SIZE = 10 * 1024 * 1024; // 10MB

export function formatFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  } else if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  } else if (bytes >= 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${bytes} B`;
}

export function getFileExtension(name: string): string {
  const ext = name.split(".").pop();
  return ext ? ext.toUpperCase() : "";
}

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.split(",")[1]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export interface EmailAttachment {
  content: string;
  filename: string;
  type: string;
}

export async function filesToEmailAttachments(files: File[]): Promise<EmailAttachment[]> {
  return Promise.all(
    files.map(async (file) => ({
      content: await fileToBase64(file),
      filename: file.name,
      type: file.type || "application/octet-stream",
    })),
  );
}
